export const isUserSubscribed = (auth) => {
    if (!auth || auth === false) return false;

    const subscriptionEnd = auth.subscriptionEnd;
    if (subscriptionEnd == null || subscriptionEnd === '') return false;

    const endTime = typeof subscriptionEnd === 'number'
        ? subscriptionEnd
        : new Date(subscriptionEnd).getTime();

    if (Number.isNaN(endTime)) return false;

    return endTime > Date.now();
};

export const handleSeeAllWithSubscription = ({ auth, onSubscribed, onShowSubscribeModal, onShowLogin }) => {
    if (!auth) {
        if (onShowLogin) onShowLogin(true);
        return;
    }

    if (isUserSubscribed(auth)) {
        onSubscribed();
    } else if (onShowSubscribeModal) {
        onShowSubscribeModal(true);
    }
};
